import { useCallback } from 'react';

import { useSearchParams } from 'react-router-dom';

import { componentsRegistry } from '../../services/componentsRegistry';
import { useFlag } from '../../services/launchDarkly';
import type { PortalOptions } from '../../stores/portal/PortalStore';
import { useStores } from '../../stores/useStores';

export function useOpenAuthWizard() {
  const { authStore, portalStore, wizardStore } = useStores();

  const [_, setSearchParams] = useSearchParams();
  const redesignFlow = useFlag<boolean>('ui_redesign_registration_flow', false);

  const openAuthWizard = useCallback(
    (flowName: string, options?: PortalOptions, initialStep = 0) => {
      authStore.setIsAuthWizardOpen(true);
      wizardStore.forceStep(initialStep);

      if (!portalStore.isVisible || options?.force) {
        portalStore.openPortal(componentsRegistry.getComponent(flowName), {
          beforeClose: () => {
            authStore.setIsAuthWizardOpen(false);

            if (authStore.isDirectLanding()) {
              authStore.clearLandingKey(setSearchParams);
            }

            if (authStore.userDataReady && authStore.authStatus !== 'authenticated') {
              authStore.setAuthStatus('authenticated');
            }
          },
          ...(redesignFlow && {
            contentClassName: 'fullscreen-modal-content',
            portalClassName: 'fullscreen-modal',
            overlayClassName: 'fullscreen-modal-overlay',
          }),
          ...options,
        });
      }
    },
    [authStore, portalStore, wizardStore, setSearchParams, redesignFlow],
  );

  return { openAuthWizard };
}
